import styled from '@emotion/styled';
import { commonColors } from 'application/theme';

export const DividerStyled = styled('div')`
  height: 1px;
  min-height: 1px;
  width: 100%;
  background: ${commonColors.grey300};
`;
